var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',_vm._l((_vm.items),function(nextItem){return _c('b-col',{key:nextItem.id,attrs:{"sm":"6","lg":"3"}},[_c('lock-card',{attrs:{"nextItem":nextItem}})],1)}))],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e0de664","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/base/LocksUnassigned.vue
// module id = null
// module chunks = 